import { APIActions, Button, CustomDialog, IconName } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import React from 'react';
import { MutationStatus } from 'react-query';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  uploadingIcon: {
    '& svg': {
      color: theme.color.icon.iconDefault,
    },
  },
  stopProcessingButton: {
    color: theme.color.state.stateError,
  },
  stopProcessingIcon: {
    color: theme.color.state.stateError,
  },
}));

const FileProcessingLabel = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <IconWithLabel
      className={classes.uploadingIcon}
      iconName={IconName.loadingIndicator}
      iconSize="M"
      label={t('components->>FileProcessing.ProcessingInProgress')}
      typographyProps={{
        variant: 'h5',
        color: 'inherit',
      }}
    />
  );
};

interface StopProcessingButtonProps {
  onActionButtonClicked: () => void;
  onCancelButtonClicked: () => void;
  actionButtonApiStatus: MutationStatus;
  isStopProcessModalOpen: boolean;
  setIsStopProcessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  apiCallError?: string;
}

const StopProcessingButton = ({
  onActionButtonClicked,
  onCancelButtonClicked,
  actionButtonApiStatus,
  isStopProcessModalOpen,
  setIsStopProcessModalOpen,
  apiCallError,
}: StopProcessingButtonProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const stopFileProcessingClickHandler = () => {
    setIsStopProcessModalOpen(true);
  };

  return (
    <>
      <CustomDialog
        open={isStopProcessModalOpen}
        title={t('components->>FileProcessing.StopFileProcessingTitle')}
        message={t('components->>FileProcessing.StopFileProcessingContent')}
        action={
          <APIActions
            onClose={() => {
              onCancelButtonClicked();
              setIsStopProcessModalOpen(false);
            }}
            apiCall={() => {
              onActionButtonClicked();
            }}
            apiStatus={actionButtonApiStatus}
            cancelString={t('components->>FileProcessing.Cancel')}
            apiString={t('components->>FileProcessing.Proceed')}
          />
        }
      />
      <Button
        variant="text"
        className={classes.stopProcessingButton}
        onClick={stopFileProcessingClickHandler}
      >
        <IconWithLabel
          className={classes.stopProcessingIcon}
          iconName={IconName.cross}
          iconSize="M"
          label={t('components->>FileProcessing.StopProcessing')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </Button>
    </>
  );
};

export { FileProcessingLabel, StopProcessingButton };
